
<ng-container *ngIf="(featureFlagService.featureFlagsLoaded$ | async); else preloader">
  <router-outlet></router-outlet>

  <!-- 
    Spinner will show when triggered to true, and feature flags are loaded. 
    Can be triggered from any guard or service. 
  -->
  @if((spinnerService.showAppWideSpinner$ | async)) {
    <ng-container *ngTemplateOutlet="preloader"></ng-container>
  }
</ng-container>

<ng-template #preloader>
  <div class="preloader spinner">
    <zbp-preloader></zbp-preloader>
  </div>
</ng-template>